module.exports = __webpack_public_path__ + "static/04-4bbdda47bcc58ff40b224a7496e1d4b7.jpg";